import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { SectionAllCards, SectionSelectors, SubSectionPreSeasonCardsGroup, SectionPreSeasonPanels } from 'components'
import PHASE from 'utils/constants/phases'
import DATA_SELECTORS from 'data/selectors'
import DATA_MOCK from 'data/tour/preSeason.json'
import GameTemplate from 'pages/templates/GameTemplate'
import { translate } from 'react-i18next'

import './Tour.css'

@connect(
    () => ({
        phase: DATA_MOCK.phase,
        selection: {},
        preSeasonData: DATA_MOCK.data,
        curvesParams: DATA_MOCK.performanceOverDeteriorationCurveParams
    })
)
@translate()
export class SecondPage extends PureComponent {
    componentWillMount() {
        const { t, preSeasonData } = this.props

        this.selected = 'pre-season-engine'
        this.selectors = DATA_SELECTORS[PHASE.PRE_SEASON].map(s => ({ ...s, label: t('game.PRE_SEASON.selectorLabel', { name: s.name }) }))
        this.selectorsIds = this.selectors.map(({ id }) => id)
        this.cardsData = this.selectors.map(({ id }) => ({
            groupId: id,
            cards: preSeasonData[id].options.map(o => ({ ...o, typeId: o.id }))
        }))
    }

    renderCardsGroup = ({ groupId, cards }) => (
        <SubSectionPreSeasonCardsGroup
            key={groupId}
            groupId={groupId}
            cards={cards}
            availableCredits={200}
            selection={{ type: '', units: 0 }}
            onSelect={undefined}
            onSelectUnits={undefined}
        />
    )

    render() {
        const { preSeasonData, curvesParams, selection, className } = this.props

        return (
            <GameTemplate className={className}>
                <SectionPreSeasonPanels data={preSeasonData} selectedGroupId={this.selected} selection={selection} curvesParams={curvesParams} isAMToolAvailable={false} isAMToolActive={false} />
                <SectionAllCards groupIds={this.selectorsIds} selectedGroupId={this.selected}>
                    {this.cardsData.map(this.renderCardsGroup)}
                </SectionAllCards>
                <SectionSelectors selectors={this.selectors} selected={this.selected} onSelect={undefined} />
            </GameTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Tour/SecondPage.js